import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { TokenService } from '../services/token.service';
import { catchError, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { setRedirectUrl } from '../../factory';
import { MsalAuthService } from '../../services/msal.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const jwtToken = tokenService.getToken();
  const entraToken = tokenService.getTokenEntra() || '';
  const authService = inject(AuthService);
  const router = inject(Router);
  const msalAuthService = inject(MsalAuthService);
  const retryHeader = 'X-Refresh-Attempt';
  const isAuthEndpoint = /\/Account\/(login-entra|login|verify-twofa|logout)$/i.test(req.url);

  if (jwtToken) {
    const bearer = `Bearer ${jwtToken}`;

    req = req.clone({
      setHeaders: {
        Authorization: bearer,
        'X-Entra-Token': entraToken,
      },
    });
  }

  // const currentFacility = authService.getCurrentFacility();
  // if (currentFacility) {
  //   req = req.clone({
  //     setHeaders: {
  //       FacilityID: currentFacility,
  //     },
  //   });
  // }

  return next(req).pipe(
    catchError((err) => {
      if (err.status === 401) {
        if (isAuthEndpoint) {
          setRedirectUrl();
          router.navigateByUrl('/login');
          return throwError(() => err);
        }

        if (req.headers.has(retryHeader)) {
          setRedirectUrl();
          router.navigateByUrl('/login');
          return throwError(() => err);
        }

        return msalAuthService.refreshTokensSilently().pipe(
          switchMap((refreshed) => {
            if (!refreshed) {
              setRedirectUrl();
              router.navigateByUrl('/login');
              return throwError(() => err);
            }

            const newJwtToken = tokenService.getToken();
            if (!newJwtToken) {
              setRedirectUrl();
              router.navigateByUrl('/login');
              return throwError(() => err);
            }

            const newEntraToken = tokenService.getTokenEntra() || '';
            const retryReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${newJwtToken}`,
                'X-Entra-Token': newEntraToken,
                [retryHeader]: '1',
              },
            });

            return next(retryReq);
          }),
          catchError((refreshErr) => {
            setRedirectUrl();
            router.navigateByUrl('/login');
            return throwError(() => refreshErr);
          })
        );
      }
      return throwError(() => err);
    })
  );
};
